import { useCallback, useRef } from 'react'
import { withStyles } from '@aura/components/styles'
import Form from '@aura/forms/form'
import FormLabel from '@aura/components/form-label'
import Button from '@aura/components/button'
import Checkbox from '@aura/components/checkbox'
import { Typography } from '@aura/components'
import FormHelperText from '@aura/components/form-helper-text'
import Grid from '@aura/components/grid'
import HorizontalGroup from '@aura/components/horizontal-group'
import Box from '@aura/components/box'
import { useTranslation, Trans } from 'react-i18next'
import { useAuraThemeSwitcher } from '@aura/components/themes'
import PropTypes from 'prop-types'
import RegistrationContainer from '../../../../components/registration-container-new'
import { showLoader } from '../../../../utils/loader-actions'
import formFields, { initialValues } from './constants/form-fields'
import styles from './styles'


const mfaIcons = {
    'dark': {
        mobile : '/img/logos/mfa/mobile_light.svg?url',
        scan: '/img/logos/mfa/scan_light.svg?url',
        security: '/img/logos/mfa/security_light.svg?url'
    },
    'light': {
        mobile : '/img/logos/mfa/mobile.svg?url',
        scan: '/img/logos/mfa/scan.svg?url',
        security: '/img/logos/mfa/security.svg?url'
    }
}


const Component = ({
    canSkip,
    classes,
    error,
    isProcessing,
    onEnroll,
    onSkip = () => {},
    userData
}) => {

    const { t: translate } = useTranslation()
    const { theme } = useAuraThemeSwitcher()
    const formRef = useRef(null)

    const { SKIP_ENROLLMENT } = formFields

    const verbiage = <div className= {classes.verbiageContainer}>{translate('mfaEnrollment.verbiage01')}<br></br><br></br> {translate('mfaEnrollment.verbiage02')} <br></br><br></br>
        <div className={classes.verbiageDiv}><img className={classes.mobileIcon} src={mfaIcons[theme.palette.mode].mobile} /><Typography className={classes.verbiageText}>{translate('mfaEnrollment.verbiage03')}</Typography></div>
        <div className={classes.verbiageDiv}><img className={classes.mobileIcon} src={mfaIcons[theme.palette.mode].scan} /> <Typography className={classes.verbiageText}>{translate('mfaEnrollment.verbiage04')}</Typography></div>
        <div className={classes.verbiageDiv}><img className={classes.mobileIcon} src={mfaIcons[theme.palette.mode].security} /> <Typography className={classes.verbiageText}>{translate('mfaEnrollment.verbiage05')}</Typography></div>
        <div className={classes.verbiageDivBottom}>
            <Trans i18nKey="mfaEnrollment.verbiage06" components={{ bold: <strong /> }} />
        </div>

        
    </div>
    const title = translate('mfa')

    const handleEnroll = useCallback(
        () => {
            if (userData?.userId) {
                showLoader()
                onEnroll({ oktaUserId: userData.userId })
            } else {
                onEnroll()
            }
        },
        [ userData ]
    )

    const footerContent = (
        <Grid className={classes.buttonContainer} container item md={12} xs={12}>
            <Grid 
                container 
                className={classes.actionRow} 
                justify={canSkip ? 'space-between' : 'flex-end'}
                style={{ justifyContent: canSkip ? 'space-between' : 'flex-end' }}
            >
                {canSkip && (
                    <Button
                        className={classes.buttonSkip}
                        onClick={() => {
                            const formValues = formRef.current?.getContext()?.values || {}
                            onSkip({ skipEnrollment: formValues[SKIP_ENROLLMENT] || false })
                        }}
                        variant="text"
                        disabled={isProcessing}>{translate('mfaEnrollment.setupLater')}
                    </Button>
                )}
                <Button
                    className={classes.buttonSubmit}
                    onClick={handleEnroll}
                    variant="contained"
                    disabled={isProcessing}>{translate('mfaEnrollment.enable')}
                </Button>
            </Grid>
        </Grid>
    )

    return (
        <RegistrationContainer {...{ footerActions: footerContent, title, verbiage }}>
            <Form {...{
                initialValues: initialValues,
                onSubmit: onSkip,
                ref: formRef
            }}>
                <Box component="div" className={classes.fieldsContainer}>
                    <Grid className={classes.mfaEnrollmentContainer} container>
                        <Grid item md={12} xs={12}>
                            {canSkip
                                ? <Grid className={classes.rememberMeContainer} item md={12}>
                                    <HorizontalGroup className={classes.checkboxContainer} gutter={0}>
                                        <Checkbox
                                            className={classes.checkbox}
                                            field={SKIP_ENROLLMENT} />
                                        <FormLabel className={classes.skipEnrollment}>{translate('mfaEnrollment.verbiage4')}</FormLabel>
                                    </HorizontalGroup>
                                </Grid>
                                : <></>}
                            <Box className={classes.warningLine}>{translate('mfaEnrollment.verbiage07')} </Box>
                            <FormHelperText error>{error && translate('oktaApiResponse.' + `${error}`)}</FormHelperText>
                        </Grid>
                    </Grid>
                </Box>
            </Form>
        </RegistrationContainer>
    )
}

Component.displayName = 'AuthenticatorsOptional'

Component.defaultProps = {
    canSkip: false
}

Component.propTypes = {
    canSkip: PropTypes.bool.isRequired,
    classes: PropTypes.shape({
        actionRow: PropTypes.object,
        button: PropTypes.object,
        buttonContainer: PropTypes.object,
        contentDivider: PropTypes.object,
        fieldsContainer: PropTypes.object,
        loader: PropTypes.object,
        mfaListContainer: PropTypes.object,
        mfaLogo: PropTypes.object,
        mfaLogoContainer: PropTypes.object,
        mfaSetupTitle: PropTypes.object,
    }),
    error: PropTypes.string,
    onEnroll: PropTypes.func,
    onSkip: PropTypes.func
}

export default withStyles(Component, styles)
